import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { inject, Injector, ModuleWithProviders, provideAppInitializer } from '@angular/core';
import { getClassName } from '@core/shared/class-name';
import { ConfigService } from '@core/shared/config';
import { ClassValidatorProviders, connectClassValidatorContainer } from '@core/shared/model';
import { NgxsModule } from '@ngxs/store';
import { CoreAbilitiesModule } from './abilities';
import { CoreAccessModule } from './access/internal/access.module';
import { ApiUrlInterceptor } from './api/interceptors/api-url.interceptor';
import { AppState } from './app-state';
import { ClientCacheModule } from './client-cache/internal/client-cache.module';
import { ConfigServiceProvider } from './config/factory';
import { CORE_CONFIG_FRONTEND } from './constants';
import { DevToolsRegistry } from './dev-tools';
import { CoreErrorModule } from './error';
import { CoreFeatureModule } from './feature';
import { I18nModule, I18nState } from './i18n';
import { CoreMessagesModule } from './messages';
import { CoreModelModule } from './model';
import { CoreProtocolModule } from './protocol';
import { CoreScopeModule } from './scope/scope.module';
import { ScopeState } from './scope/scope.state';
import { localStorageProvider, sessionStorageProvider } from './providers';
import { PageService, PageState } from './page-state';
import * as i0 from "@angular/core";
import * as i1 from "./dev-tools";
import * as i2 from "./model/model.module";
import * as i3 from "./client-cache/internal/client-cache.module";
import * as i4 from "@ngxs/store";
import * as i5 from "./protocol/protocol.module";
import * as i6 from "./i18n/i18n.module";
/**
 * TODO: this is a mess. Find a well working combination of forRoot and decorator.
 * idea: forRoot can store config in provider, then forFeature can use it?
 */
export let CoreFrontendSharedModule = /*#__PURE__*/(() => {
  class CoreFrontendSharedModule {
    static forRoot(config) {
      return {
        ngModule: CoreFrontendSharedModule,
        providers: [
        // ConfigServiceProvider,
        {
          provide: CORE_CONFIG_FRONTEND,
          useValue: config
        }]
      };
    }
    constructor(injector, debug) {
      connectClassValidatorContainer(injector);
      debug.exposeDebugFunction(['Http Interceptors'], () => {
        const interc = injector.get(HTTP_INTERCEPTORS);
        const classNames = interc.map(i => getClassName(i));
        return {
          warning1: 'for some reason, some interceptors are active but not listed when injecting HTTP_INTERCEPTORS.',
          warning2: 'ApiUrlInterceptor is being listed since providing it outside of forRoot().',
          warning3: 'MaintenanceModeInterceptor is not listed but active.',
          foundInterceptors: classNames
        };
      });
      debug.exposeDebugFunction(['Config Inspection'], {
        displayName: 'Config: Inspect'
      }, () => {
        const config = injector.get(ConfigService);
        return config.getStaticConfig().getDebugData();
      });
    }
    static {
      this.ɵfac = function CoreFrontendSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreFrontendSharedModule)(i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i1.DevToolsRegistry));
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CoreFrontendSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [{
          provide: HTTP_INTERCEPTORS,
          multi: true,
          useClass: ApiUrlInterceptor
        }, ConfigServiceProvider, ...ClassValidatorProviders, localStorageProvider, sessionStorageProvider, provideAppInitializer(() => {
          return (service => {
            return service.initialize();
          })(inject(PageService));
        })],
        imports: [CommonModule, CoreErrorModule, CoreMessagesModule, CoreModelModule.forRoot(), CoreAccessModule, ClientCacheModule.forRoot(), CoreScopeModule, CoreFeatureModule, CoreAbilitiesModule, NgxsModule.forFeature([AppState, ScopeState, I18nState, PageState]), CoreProtocolModule.forRoot(), I18nModule.forRoot({}), CoreErrorModule, CoreMessagesModule, CoreModelModule, CoreAccessModule, CoreScopeModule, CoreFeatureModule, CoreAbilitiesModule, CoreProtocolModule, I18nModule]
      });
    }
  }
  return CoreFrontendSharedModule;
})();